import { RedactionAnnotationEdit } from './redaction-annotation-edit.model';

export class RedactionAnnotationCreatePdfRequest {
  docId: string;
  isRedaction: boolean;
  edits: RedactionAnnotationEdit[];

  constructor(docId: string, isRedaction: boolean, edits: RedactionAnnotationEdit[]) {
    this.docId = docId;
    this.isRedaction = isRedaction;
    this.edits = edits;
  }
}
